import classes from './CronPlanningPreview.module.scss';
import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import cronParser from 'cron-parser';
import moment from 'moment';

interface Props {
  cron: string,
  nextExecutionDates?: number
}

const DEFAULT_NEXT_DATES_COUNT: number = 5;

const calculateNextExecutions = (cron: string, nextDateCount: number): Date[] => {
  try {
    const tmp: Date[] = [];
    const options = {
      currentDate: new Date(),
      iterator: true,
    };
    const interval: any = cronParser.parseExpression(cron, options);
    const MAX = nextDateCount ?? DEFAULT_NEXT_DATES_COUNT;
    for (let i = 0; i < MAX; i++) {
      const nex = interval.next();
      tmp.push(nex.value.toDate());
    }
    return tmp;
  } catch (error) {
    console.error('Crontab parsing error !', error);
    return [];
  }
};

const CronPlanningPreview = ({ cron, nextExecutionDates = DEFAULT_NEXT_DATES_COUNT }: Props) => {

  const { t: translate } = useTranslation();

  const dates = calculateNextExecutions(cron, nextExecutionDates);

  const planning = useMemo(() => {
    return dates.map((item: Date, index: number) => {
      return <span className={ classes['result-preview__item'] } key={ index }>
        <i className="pi pi-calendar"></i>
        <span>{ moment(item).format('DD MMMM YYYY - HH:mm') }</span>
      </span>;
    });
  }, [dates]);

  const timeOffset = useMemo(() => {
    const offset = new Date().getTimezoneOffset();
    const utcOffset = -1 * offset / 60; // UTC - TimeZone => result = -120 minutes = -2h = UTC +2
    return `${ utcOffset.toString().padStart(2, '0') }:00`;
  }, []);

  return (
    <section className={ classes['cron-panel__result-preview'] }>
      <span className={ classes['result-preview__locale'] }>
        <span>
          { translate('cron-tab.next_run', { executionsNumber: nextExecutionDates }) }
        </span>
        <span>
          { translate('cron-tab.utc', { offset: timeOffset }) }
        </span>
      </span>
      <span className={ classes['result-preview__planning'] }>
        { planning }
      </span>
    </section>
  );
};

export default CronPlanningPreview;